import {
	Box,
	FormControl,
	IconButton,
	InputAdornment,
	ListItemIcon,
	MenuItem,
	Select,
	TextField,
	ThemeProvider,
	Typography,
} from '@mui/material';
import { FormLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import SearchIcon from '../../../assets/SVGs/searchMenuIcon.svg';
import React, { useEffect, useState } from 'react';
import { theme } from '../../../theme/theme';
import {
	TabNavigation,
	TabNavigationItem,
} from '@walmart-dataventures/shared-components';
import CloseIcon from '../../../assets/SVGs/close.svg';
import Check from '../../../assets/SVGs/LeadingCheck.svg';
import { useStyles } from './styles';
import { WMT_ATTR, CUSTOM_ATTR, CATMANVIEW } from '../../../constants/constant';
import { useDispatch } from 'react-redux';
import {
	setBreakDownByType,
	setViewByType,
} from '../../../redux/actions/tableActions';

const TableMenu = (props) => {
	const {
		label,
		formId,
		customOptions,
		wmtOptions,
		selectedValue,
		handleValueChange,
		selectedView,
	} = props;

	const menuItems = {
		0: wmtOptions,
		1: customOptions,
	};

	const [tabIdx, setTabIdx] = useState(0);
	const [selectedOption, setSelectedOption] = useState(selectedValue);
	const [searchValue, setSearchValue] = useState('');
	const [menuItemList, setMenuItemList] = useState(wmtOptions);
	const [tabsArray, setTabsArray] = useState([
		{
			id: 0,
			label: 'WMT Attribute',
		},
		{ id: 1, label: 'Custom Attribute' },
	]);
	const dispatch = useDispatch();

	const classes = useStyles();

	const handleChange = (event) => {
		setSelectedOption(event.target.value);
		setSearchValue('');
		if (tabIdx === 0) {
			if (label === 'View By') {
				dispatch(setViewByType(WMT_ATTR));
			} else {
				dispatch(setBreakDownByType(WMT_ATTR));
			}
		} else {
			if (label === 'View By') {
				dispatch(setViewByType(CUSTOM_ATTR));
			} else {
				dispatch(setBreakDownByType(CUSTOM_ATTR));
			}
		}
		handleValueChange(event.target.value);
	};

	const handleTabClick = (event, tabData) => {
		event.preventDefault();
		event.stopPropagation();

		tabData.id === 0
			? setMenuItemList(wmtOptions)
			: setMenuItemList(customOptions);
		setTabIdx(tabData.id);
	};

	useEffect(() => {
		setSelectedOption(selectedValue);
	}, [selectedValue]);

	useEffect(() => {
		tabIdx === 0 ? setMenuItemList(wmtOptions) : setMenuItemList(customOptions);
	}, [wmtOptions]);

	useEffect(() => {
		if (selectedView === CATMANVIEW) {
			setTabsArray([
				{
					id: 0,
					label: 'WMT Attribute',
				},
			]);
			setTabIdx(0); // for wmt attributes
		} else {
			setTabsArray([
				{
					id: 0,
					label: 'WMT Attribute',
				},
				{ id: 1, label: 'Custom Attribute' },
			]);
		}
	}, [selectedView]);

	return (
		<ThemeProvider theme={theme}>
			<FormControl className={classes.formControl} size="small">
				<FormLabel id={formId} className={classes.label}>
					{label}
				</FormLabel>

				<Select
					labelId={formId}
					className={classes.select}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					value={selectedOption}
					onClose={() => {
						setSearchValue('');
						setMenuItemList(menuItems[tabIdx]);
					}}
					renderValue={(param) =>
						[...customOptions, ...wmtOptions].find(
							(item) => item.value === param
						)?.label
					}
					MenuProps={{
						classes: { paper: classes.menuList },
						sx: {
							'&& .MuiMenuItem-root': {
								paddingLeft: '36px',
							},
							'&& .MuiListItemIcon-root': {
								width: 'auto !important',
								minWidth: '0px',
							},
							'&& .MuiPaper-root': {
								width: '279px',
								left:
									label === 'View By' ? '30px !important' : '226px !important',
								marginTop: '4px',
							},
							'&& .Mui-selected': {
								backgroundColor: 'transparent',
								display: 'flex',
								justifyContent: 'flex-start',
								paddingLeft: '10px',
							},
							'&& .Mui-selected:hover': {
								backgroundColor: 'transparent',
							},
						},
					}}>
					<TabNavigation UNSAFE_style={{ boxShadow: 'none', padding: '8px' }}>
						{tabsArray.map((tab) => (
							<TabNavigationItem
								key={tab.id}
								isCurrent={tab.id === tabIdx}
								onClick={(e) => handleTabClick(e, tab)}>
								{tab?.label}
							</TabNavigationItem>
						))}
					</TabNavigation>
					{tabIdx == 1 && (
						<TextField
							className={classes.searchField}
							type="text"
							value={searchValue}
							onKeyDown={(e) => e.stopPropagation()}
							placeholder="Search"
							sx={{
								padding: '8px 0',
								margin: '0 8px',
								color: '#2E2F32',
								border: 'none !important',
								width: '-webkit-fill-available',
								'& .MuiFormControl-root': {
									width: '-webkit-fill-available',
								},
							}}
							renderValue={() => searchValue}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<img src={SearchIcon} alt="search" />
									</InputAdornment>
								),
								endAdornment: searchValue !== '' && (
									<InputAdornment position="end">
										<IconButton
											onClick={() => {
												setSearchValue('');
												setMenuItemList(customOptions);
											}}>
											<img src={CloseIcon} alt="clear" />
										</IconButton>
									</InputAdornment>
								),
							}}
							onChange={(e) => {
								e.preventDefault();
								setSearchValue(e.target.value);
								const searchableList = menuItems[tabIdx].filter((option) =>
									String(option?.label)
										.toLowerCase()
										.includes(e.target.value.toLowerCase())
								);

								setMenuItemList(searchableList);
							}}
						/>
					)}
					{menuItemList.map((item) => (
						<MenuItem
							role="option"
							key={item.value}
							className={classes.menuItem}
							value={item.value}
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								'&&:first-of-type': {
									marginTop: '4px',
								},
							}}>
							{selectedOption === item.value && (
								<ListItemIcon
									sx={{
										minWidth: 0,
									}}>
									<img src={Check} alt="check-icon" />
								</ListItemIcon>
							)}
							<Typography
								sx={{
									color: '#2E2F32',
									fontSize: '14px',
									lineHeight: '20px',
									marginLeft: selectedOption === item.value ? '0px' : '24px',
								}}>
								{item?.label}
							</Typography>
						</MenuItem>
					))}

					{/**  when no elements found in search */}
					{menuItemList.length === 0 && (
						<Box
							sx={{
								margin: '24px 16px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}>
							<Typography
								sx={{
									lineHeight: '20px',
									fontSize: '14px',
									fontWeight: 400,
									color: '#74767C',
								}}>
								No matches found for this search
							</Typography>
						</Box>
					)}
				</Select>
			</FormControl>
		</ThemeProvider>
	);
};

TableMenu.defaultProps = {
	selectedValue: '',
	customOptions: [],
	wmtOptions: [],
};

TableMenu.propTypes = {
	label: PropTypes.string,
	// selectedFilter: PropTypes.string,
	isViewBy: PropTypes.boolean,
	formId: PropTypes.string,
	wmtOptions: PropTypes.arrayOf(Object),
	customOptions: PropTypes.arrayOf(Object),
	handleValueChange: PropTypes.func,
	selectedValue: PropTypes.string,
	selectedView: PropTypes.string,
};

export default TableMenu;
